var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.HasUsedWorkspace)?_c('recycle-bin',{attrs:{"tabletype":_vm.$route.path === '/enterprise/recycle' ? 'companyList' : 'projectList',"forSpaceEnterprise":false}}):_vm._e(),_c('LoadingGif',{attrs:{"loadingShow":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }